module.exports = __webpack_public_path__ + "img/solutionBanner4.55a3ac2c.png";